<template>
	<div class="global-home-sr" :class="{ 'global-home-sr--rail': isListCreative }">
		<h2 v-if="!isListCreative" class="global-home-sr__heading">{{ $t('WEBAPP_MODULE_MAIN_TODAYS_PICK') }}</h2>

		<div class="global-home-sr__ad">
			<slot />
		</div>
	</div>
</template>

<script setup lang="ts">
withDefaults(
	defineProps<{
		isListCreative?: boolean;
	}>(),
	{
		isListCreative: false,
	}
);
</script>

<style lang="scss" scoped>
.global-home-sr {
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;
	padding: 0 7.5vw;

	@media (max-width: 550px) {
		padding: 0 5vw;
	}

	&--rail &__ad {
		margin-inline: -7.5vw;

		@media (max-width: 550px) {
			margin-inline: -5vw;
		}
	}

	&__heading {
		margin: 0;
		font-size: 24px;
		font-weight: 900;
		color: #eaebee;
		text-align: left;

		@media (max-width: 550px) {
			font-size: 20px;
			text-align: center;
		}
	}
}
</style>
